import { useEffect, useMemo, useState } from "react";
import { Col } from "reactstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPenToSquare,
  faTrash,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";
import ModalFormCp from "../modal/ModalCP";

export default function SilabusTab({
  selectedMatpel,
  selectedSemesterId,
  selectedAcademicYearId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  setSelectedCp,
  nameCollator,
  ToastSuccess,
  ToastError,
}) {
  const [cpDataByMatpel, setCpDataByMatpel] = useState({});
  const [tpDataByCp, setTpDataByCp] = useState({});
  const [showModalCp, setShowModalCp] = useState(false);
  const [isFetchingCp, setIsFetchingCp] = useState(false);
  const [isSubmittingCp, setIsSubmittingCp] = useState(false);
  const [deletingCpId, setDeletingCpId] = useState(null);
  const [formCp, setFormCp] = useState({
    nama_cp: "",
    topik: "",
    keterangan: "",
  });
  const [editCpId, setEditCpId] = useState(null);
  const [searchCp, setSearchCp] = useState("");

  const getCpArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const groupCpByMatpel = (rows = []) => {
    return rows.reduce((acc, item) => {
      const matpelId =
        item?.ysb_matpel_id ||
        item?.matpel_id ||
        item?.id_matpel ||
        "tanpa_matpel";

      if (!acc[matpelId]) acc[matpelId] = [];

      acc[matpelId].push({
        id: item?.id,
        ysb_fase_id: item?.ysb_fase_id || "",
        ysb_academic_year_id: item?.ysb_academic_year_id || "",
        ysb_semester_id: item?.ysb_semester_id || "",
        ysb_branch_id: item?.ysb_branch_id || "",
        ysb_school_id: item?.ysb_school_id || "",
        ysb_grade_level_id: item?.ysb_grade_level_id || "",
        ysb_kelas_id: item?.ysb_kelas_id || "",
        ysb_matpel_id: item?.ysb_matpel_id || matpelId,
        nama_cp: item?.name_cp || item?.nama_cp || "",
        topik: item?.name_topic || item?.topik || "",
        keterangan: item?.description || item?.keterangan || "",
        raw: item,
      });

      return acc;
    }, {});
  };

  const getTpArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const groupTpByCp = (rows = []) => {
    return rows.reduce((acc, item) => {
      const cpId =
        item?.ysb_matpel_cp_id ||
        item?.ysb_cp_id ||
        item?.cp_id ||
        item?.matpel_cp_id ||
        item?.id_cp ||
        "";

      if (!cpId) return acc;

      if (!acc[cpId]) acc[cpId] = [];
      acc[cpId].push(item);

      return acc;
    }, {});
  };

  const isSameSelectedContext = (item) => {
    const selectedMatpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";

    const selectedGradeIds = Array.isArray(selectedMatpel?.selected_grade_level_ids)
      ? selectedMatpel.selected_grade_level_ids.map(String)
      : [selectedMatpel?.ysb_grade_level_id].filter(Boolean).map(String);

    const selectedKelasIds = Array.isArray(selectedMatpel?.selected_kelas_ids)
      ? selectedMatpel.selected_kelas_ids.map(String)
      : (selectedMatpel?.kelas_list || [])
          .map((kelas) => kelas?.ysb_kelas_id)
          .filter(Boolean)
          .map(String);

    const itemMatpelId =
      item?.ysb_matpel_id ||
      item?.matpel_id ||
      item?.id_matpel ||
      item?.raw?.ysb_matpel_id ||
      "";

    const itemGradeId =
      item?.ysb_grade_level_id ||
      item?.raw?.ysb_grade_level_id ||
      "";

    const itemKelasId =
      item?.ysb_kelas_id ||
      item?.raw?.ysb_kelas_id ||
      "";

    const itemAcademicYearId =
      item?.ysb_academic_year_id ||
      item?.raw?.ysb_academic_year_id ||
      "";

    const itemSemesterId =
      item?.ysb_semester_id ||
      item?.raw?.ysb_semester_id ||
      "";

    const sameMatpel = String(itemMatpelId) === String(selectedMatpelId);

    const sameGrade =
      !itemGradeId ||
      selectedGradeIds.length === 0 ||
      selectedGradeIds.includes(String(itemGradeId));

    const sameKelas =
      !itemKelasId ||
      selectedKelasIds.length === 0 ||
      selectedKelasIds.includes(String(itemKelasId));

    const sameAcademicYear =
      !itemAcademicYearId ||
      !selectedAcademicYearId ||
      String(itemAcademicYearId) === String(selectedAcademicYearId);

    const sameSemester =
      !itemSemesterId ||
      !selectedSemesterId ||
      String(itemSemesterId) === String(selectedSemesterId);

    return sameMatpel && sameGrade && sameKelas && sameAcademicYear && sameSemester;
  };

  const getTpData = async () => {
    try {
      const token = getToken();
      
      const response = await APISD.get("/api/matpels-tp", {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      const rows = getTpArrayFromResponse(response?.data);
      setTpDataByCp(groupTpByCp(rows));
    } catch (error) {
      console.log("Gagal mengambil data TP:", error);
      setTpDataByCp({});
    }
  };

  const getCpData = async () => {
    setIsFetchingCp(true);

    try {
      const token = getToken();

      const response = await APISD.get("/api/matpels-cp", {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      const rows = getCpArrayFromResponse(response?.data);
        setCpDataByMatpel(groupCpByMatpel(rows));
    } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error?.response?.data?.message || "Gagal mengambil data CP",
        });
    } finally {
        setIsFetchingCp(false);
      }
  };

  useEffect(() => {
    if (selectedMatpel?.id) {
      getCpData();
      getTpData();
      setSearchCp("");
      resetFormCp();
    }
  }, [
    selectedMatpel?.id,
    selectedMatpel?.ysb_grade_level_id,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const currentCpData = useMemo(() => {
    if (!selectedMatpel?.id) return [];

    const matpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id;
    const rows = cpDataByMatpel[matpelId] || [];

    return rows.filter(isSameSelectedContext);
  }, [
    cpDataByMatpel,
    selectedMatpel,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const filteredCpData = useMemo(() => {
    const q = (searchCp || "").trim().toLowerCase();

    const base = !q
      ? currentCpData || []
      : (currentCpData || []).filter((item) => {
          const namaCp = (item?.nama_cp || "").toString().toLowerCase();
          const topik = (item?.topik || "").toString().toLowerCase();
          const keterangan = (item?.keterangan || "").toString().toLowerCase();

          return (
            namaCp.includes(q) ||
            topik.includes(q) ||
            keterangan.includes(q)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.nama_cp || "").toString().trim(),
        (b?.nama_cp || "").toString().trim()
      )
    );
  }, [currentCpData, searchCp, nameCollator]);

  const resetFormCp = () => {
    setFormCp({
      nama_cp: "",
      topik: "",
      keterangan: "",
    });
    setEditCpId(null);
  };

  const handleOpenAddCp = () => {
    resetFormCp();
    setShowModalCp(true);
  };

  const handleChangeFormCp = (e) => {
    const { name, value } = e.target;

    setFormCp((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitCp = async (e) => {
    e.preventDefault();

    if (!selectedMatpel?.id) {
      ToastError.fire({
        icon: "error",
        title: "Mata pelajaran belum dipilih",
      });
      return;
    }

    if (!formCp.nama_cp.trim()) {
      ToastError.fire({
        icon: "error",
        title: "Nama CP wajib diisi",
      });
      return;
    }

    const token = getToken();
    const userId = getUserId();

    const payload = {
      ysb_fase_id: "",
      ysb_academic_year_id: selectedAcademicYearId || "",
      ysb_semester_id: selectedSemesterId || "",
      ysb_branch_id: getBranchId(),
      ysb_school_id: getSchoolId(),
      ysb_grade_level_id: selectedMatpel?.ysb_grade_level_id || "",
      // ysb_kelas_id: selectedMatpel?.ysb_kelas_id || "",
      ysb_kelas_id:
        selectedMatpel?.ysb_kelas_id ||
        selectedMatpel?.selected_kelas_ids?.[0] ||
        "",
      // ysb_matpel_id: selectedMatpel?.id || "",
      ysb_matpel_id: selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "",
      name_cp: formCp.nama_cp.trim(),
      name_topic: formCp.topik?.trim() || "",
      description: formCp.keterangan?.trim() || "",
      user_id: userId,
    };

    setIsSubmittingCp(true);

    try {
      let response;

      if (editCpId) {
        response = await APISD.put(`/api/matpels-cp/${editCpId}`, payload, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
      } else {
        response = await APISD.post("/api/matpels-cp/store", payload, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
      }

      ToastSuccess.fire({
        icon: "success",
        title:
          response?.data?.message ||
          (editCpId ? "Data CP berhasil diupdate" : "Data CP berhasil disimpan"),
      });

      resetFormCp();
      setShowModalCp(false);
      await getCpData();
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          (editCpId ? "Gagal update data CP" : "Gagal menyimpan data CP"),
      });
    } finally {
      setIsSubmittingCp(false);
    }
  };

  const handleEditCp = (item) => {
    setEditCpId(item.id);
    setFormCp({
      nama_cp: item.nama_cp || "",
      topik: item.topik || "",
      keterangan: item.keterangan || "",
    });

    setShowModalCp(true);
  };

  const handleDeleteCp = (item) => {
    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: "Data CP dan TP di dalamnya akan dihapus",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const token = getToken();
      setDeletingCpId(item.id);

      try {
        const response = await APISD.delete(`/api/matpels-cp/${item.id}`, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });

        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data CP berhasil dihapus",
        });

        await getCpData();

        if (editCpId === item.id) {
          resetFormCp();
          setShowModalCp(false);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error?.response?.data?.message || "Gagal menghapus data CP",
        });
      } finally {
        setDeletingCpId(null);
      }
    });
  };

  return (
    <>
      <ModalFormCp
        show={showModalCp}
        onHide={() => {
          if (isSubmittingCp) return;
          setShowModalCp(false);
          resetFormCp();
        }}
        editCpId={editCpId}
        formCp={formCp}
        handleChangeFormCp={handleChangeFormCp}
        handleSubmitCp={handleSubmitCp}
        isSubmittingCp={isSubmittingCp}
      />

      <div className="d-flex mt-4 mb-4">
        <div className="at-search">
          <input
            className="at-input"
            placeholder="Cari CP, topik, atau keterangan"
            value={searchCp}
            onChange={(e) => setSearchCp(e.target.value)}
          />
        </div>

        <div className="ml-auto">
          <button
            type="button"
            onClick={handleOpenAddCp}
            className="btn btn-create mr-2"
            style={{
              borderRadius: 12,
              padding: "8px 14px",
              boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
              fontWeight: 600,
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Buat CP
          </button>
        </div>
      </div>

      <Col xl="12" sm="12">
        <div className="mt-3 body-table">
          {/* <table className="table dt-responsive nowrap w-100"> */}
           <table className="table table-hover custom-hover-table table-border-style" id="basic-datatable">
            <thead>
              <tr>
                <th >CP</th>
                <th >Topik</th>
                <th >Keterangan</th>
                <th style={{ width: "100px" }}>
                  Total TP
                </th>
                <th style={{ width: "250px" }}>Aksi</th>
              </tr>
            </thead>

            <tbody>
              {isFetchingCp ? (
                <tr>
                  <td colSpan="5" className="text-center" style={{ padding: 15 }}>
                    Mengambil data CP...
                  </td>
                </tr>
              ) : filteredCpData.length > 0 ? (
                filteredCpData.map((row, index) => {
                  const totalTp = tpDataByCp[row.id]?.length || 0;
                  // const totalTp =
                  //       Number(row?.raw?.total_tp || row?.raw?.total_tp_count || row?.raw?.jumlah_tp || 0) ||
                  //       tpDataByCp[row.id]?.length ||
                  //       0;

                  return (
                     <tr key={row?.id || index}>
                    <td style={{ lineHeight: "2", fontWeight: 600 }}>
                      {row?.nama_cp || "-"}
                    </td>
                    <td style={{ lineHeight: "2" }}>{row?.topik || "-"}</td>
                    <td style={{ lineHeight: "2" }}>{row?.keterangan || "-"}</td>
                    <td
                                style={{
                                  lineHeight: "2",
                                  textAlign: "center",
                                  fontWeight: 700,
                                }}
                              >
                                 {totalTp}
                      </td>

                    <td style={{ textAlign: "center", lineHeight: "2" }}>
                      <div
                        className="d-flex justify-content-center"
                        style={{ gap: 8, flexWrap: "wrap" }}
                      >
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => setSelectedCp(row)}
                              style={{
                                borderRadius: 8,
                                fontWeight: 600,
                              }}
                          >
                            TP
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-warning"
                            onClick={() => handleEditCp(row)}
                            style={{
                              borderRadius: 8,
                              color: "#fff",
                              fontWeight: 600,
                            }}
                          >
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </button>

                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteCp(row)}
                            disabled={deletingCpId === row.id}
                            style={{ borderRadius: 8, fontWeight: 600 }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                      </div>
                    </td>
                  </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center" style={{ padding: 20 }}>
                    Data CP belum tersedia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Col>
    </>
  );
}